export const stepIconStyles = {
  root: {
    backgroundColor: '#e0e0e0',
    zIndex: 1,
    color: '#fff',
    width: 44,
    height: 44,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    border: '3px solid transparent',
    '&:hover': {
      transform: 'scale(1.1)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
  },
  active: {
    background: '#FF5246',
    boxShadow: '0 4px 10px rgba(255, 82, 70, 0.4)',
  },
  completed: {
    background: '#4caf50',
  },
  pending: {
    background: '#fff',
    border: '3px solid #bdbdbd',
    color: '#bdbdbd',
  },
  warning: {
    background: '#fff',
    border: '3px solid #FF5246',
    color: '#FF5246',
  },
};

export default theme => ({
  root: {
    height: '100vh',
    width: '100%',
    backgroundColor: theme.palette.grey[50],
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  paper: {
    overflow: 'hidden',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(3),
    marginTop: 0,
  },
  tabsContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'white',
    flexShrink: 0,
  },
  tab: {
    minHeight: 48,
    display: 'flex',
    alignItems: 'center',
    '&.Mui-selected': {
      color: '#FF5246 !important',
    },
    '&.Mui-selected .MuiTab-iconWrapper': {
      color: '#FF5246',
    },
    '&.Mui-selected svg': {
      color: '#FF5246',
    },
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      display: 'flex',
    },
    '& .MuiTab-iconWrapper': {
      marginRight: 0,
      marginBottom: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'middle',
      '& svg': {
        fontSize: '18px',
        verticalAlign: 'middle',
      },
    },
    '& .MuiTab-labelIcon': {
      minHeight: 48,
    },
    '& span': {
      display: 'inline-flex',
      alignItems: 'center',
      verticalAlign: 'middle',
    },
  },
  tabsIndicator: {
    backgroundColor: '#FF5246',
    height: 3,
    marginBottom: 4,
  },
  formContent: {
    padding: theme.spacing(3),
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
  },
  sectionGap: {
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(3),
    },
  },
  cardSelectable: {
    cursor: 'pointer',
    transition: 'all 0.3s',
    '&:hover': {
      borderColor: '#5c6bc0',
    },
  },
  cardSelected: {
    border: '2px solid #5c6bc0',
    backgroundColor: 'rgba(92, 107, 192, 0.06)',
  },
  cardIcon: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    marginBottom: theme.spacing(2),
  },
  configSection: {
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.grey[50],
  },
  scaleItem: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    marginBottom: theme.spacing(2),
  },
  bonusItem: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderLeft: '4px solid #1976d2',
    marginBottom: theme.spacing(2),
  },
  penaltyItem: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderLeft: `4px solid ${theme.palette.error.main}`,
    marginBottom: theme.spacing(2),
  },
  groupItem: {
    padding: theme.spacing(2),
    backgroundColor: `${theme.palette.success.light}20`,
    border: `2px solid ${theme.palette.success.light}`,
    marginBottom: theme.spacing(2.5),
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  footer: {
    padding: theme.spacing(2, 3),
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  alert: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
  },
  alertInfo: {
    backgroundColor: '#e3f2fd',
    border: '1px solid #90caf9',
    color: '#0d47a1',
  },
  alertWarning: {
    backgroundColor: '#fff3e0',
    border: '1px solid #ffb74d',
    color: '#e65100',
  },
  alertError: {
    backgroundColor: '#ffebee',
    border: '1px solid #ef5350',
    color: '#c62828',
  },
  alertSuccess: {
    backgroundColor: '#e8f5e9',
    border: '1px solid #66bb6a',
    color: '#2e7d32',
  },
});
